import React, {useState} from "react";
import {PermissionGroupInfo} from "./interfaces";
import SearchInput from "./SearchInput";
import ToggleRow from "./ToggleRow";

export default function GroupToggleList(props: {
    groups: PermissionGroupInfo[],
    memberGroups: Set<string>,
    onToggle: (group: string, isMember: boolean) => void
}) {
    const [search, setSearch] = useState("");
    const query = search.trim().toLowerCase();

    const visible = query
        ? props.groups.filter(g => g.name.toLowerCase().includes(query) || (g.title ?? "").toLowerCase().includes(query))
        : props.groups;

    return (
        <div className="space-y-3">
            <SearchInput value={search} onChange={setSearch} placeholder="Search groups..."/>

            <div className="space-y-1">
                {visible.map(g => {
                    const isMember = props.memberGroups.has(g.name);
                    const showName = g.title && g.title.toLowerCase() !== g.name.toLowerCase();
                    return (
                        <ToggleRow
                            key={g.name}
                            label={<span>{g.title || g.name}{showName && <span className="ml-2 text-xs opacity-70">{g.name}</span>}</span>}
                            active={isMember}
                            onClick={() => props.onToggle(g.name, isMember)}
                        />
                    );
                })}
                {visible.length === 0 && (
                    <p className="text-neutral-500 text-sm text-center py-6">No groups match your search.</p>
                )}
            </div>
        </div>
    )
}
